const bannerSelector = '.banner';
const applyButtonSelector = '.header-apply';

function toggleApplyButton() {
  const bannerEl = document.querySelector(bannerSelector);
  const applyButtonEls = document.querySelectorAll(applyButtonSelector);

  if (applyButtonEls.length === 0 || !bannerEl) {
    applyButtonEls.forEach(el => {
      // eslint-disable-next-line no-param-reassign
      el.style.display = 'block';
    });
    return;
  }

  const scrollValue = document.documentElement.scrollTop + 80;
  const offsetTop = bannerEl.offsetTop + bannerEl.offsetHeight;

  let display = 'none';
  if (scrollValue > offsetTop) {
    display = 'block';
  }

  applyButtonEls.forEach(el => {
    // eslint-disable-next-line no-param-reassign
    el.style.display = display;
  });
}

function initialize() {
  toggleApplyButton();

  const possibleScrollElements = [window];
  possibleScrollElements.forEach(
    el => el.addEventListener('scroll', toggleApplyButton),
  );
}

export default {
  initialize,
};
